import React, { createContext, useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "./api";

const SiteSettingsContext = createContext(null);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/settings/public");
      setSettings(data);
    } catch {
      setSettings({});
    }
  };

  useEffect(() => {
    load();
    // Allow other components (e.g. admin editor) to trigger reload
    const handler = () => load();
    window.addEventListener("site-settings:reload", handler);
    return () => window.removeEventListener("site-settings:reload", handler);
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, reload: load }}>
      {/* Inject admin-editable SEO/verification tags globally */}
      {settings && (
        <Helmet>
          {settings.seo_google_verification && (
            <meta name="google-site-verification" content={settings.seo_google_verification} />
          )}
          {settings.seo_bing_verification && (
            <meta name="msvalidate.01" content={settings.seo_bing_verification} />
          )}
          {settings.seo_description && (
            <meta name="description" content={settings.seo_description} />
          )}
          {settings.seo_keywords && (
            <meta name="keywords" content={settings.seo_keywords} />
          )}
          {settings.seo_og_image && (
            <meta property="og:image" content={settings.seo_og_image} />
          )}
          {settings.seo_og_image && (
            <meta name="twitter:image" content={settings.seo_og_image} />
          )}
        </Helmet>
      )}
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const ctx = useContext(SiteSettingsContext);
  return ctx?.settings || {};
};

export const useReloadSiteSettings = () => {
  const ctx = useContext(SiteSettingsContext);
  return ctx?.reload || (() => {});
};
